import { getQueryMethod, resources, entities, getURLParams } from '../utils';
const { meloAPI } = resources;
const { admins } = entities;

const query = getQueryMethod(meloAPI, admins);

const endpoints = {
  getCatalogs: async catalogName => {
    const queryParams = getURLParams({ catalogName });
    return await query(`catalogs?${queryParams}`);
  }
};

export default endpoints;
